import MainTitle from '../MainTitle/MainTitle';
import styles from './AboutUs.module.css';
import { FormattedMessage } from 'react-intl';

function AboutUs() {
  return (
    <section className={styles.aboutSection} id="aboutUsId">
      <div className={styles.containerCustom}>
        <MainTitle
          title={<FormattedMessage id="aboutUs.title" defaultMessage="About Us" />}
          subTitleLine={
            <FormattedMessage
              id="aboutUs.subtitle"
              defaultMessage="Discover our mission to transform ethnic fashion through sustainable, circular practices."
            />
          }
        />

        <div className={styles.aboutContainer}>
          {/* Mission Card */}
          <div className={styles.aboutCategory}>
            <h3 className={styles.categoryTitle}>
              <FormattedMessage id="aboutUs.mission.title" defaultMessage="Our Mission" />
            </h3>
            <div className={styles.contentList}>
              <div className={styles.contentItem}>
                <div className={styles.contentBullet}></div>
                <p className={styles.contentText}>
                  <FormattedMessage
                    id="aboutUs.mission.point1"
                    defaultMessage="At RET, we began with a simple yet powerful mission: to shift from fast fashion to circular fashion—especially in the world of ethnic wear."
                  />
                </p>
              </div>
              <div className={styles.contentItem}>
                <div className={styles.contentBullet}></div>
                <p className={styles.contentText}>
                  <FormattedMessage
                    id="aboutUs.mission.point2"
                    defaultMessage="Ethnic outfits are timeless, beautiful, and often come with a high price tag. Most of us invest in these stunning pieces, wear them once or twice, and then let them sit untouched in our closets."
                  />
                </p>
              </div>
              <div className={styles.contentItem}>
                <div className={styles.contentBullet}></div>
                <p className={styles.contentText}>
                  <FormattedMessage
                    id="aboutUs.mission.point3"
                    defaultMessage="We believe it doesn't have to be that way. RET was created to give these cherished garments a second life."
                  />
                </p>
              </div>
            </div>
          </div>

          {/* Vision Card */}
          <div className={styles.aboutCategory}>
            <h3 className={styles.categoryTitle}>
              <FormattedMessage id="aboutUs.vision.title" defaultMessage="Our Vision" />
            </h3>
            <div className={styles.contentList}>
              <div className={styles.contentItem}>
                <div className={styles.contentBullet}></div>
                <p className={styles.contentText}>
                  <FormattedMessage
                    id="aboutUs.vision.point1"
                    defaultMessage="Turning cherished garments into a source of income for owners and a stylish, affordable, commitment-free option for renters."
                  />
                </p>
              </div>
              <div className={styles.contentItem}>
                <div className={styles.contentBullet}></div>
                <p className={styles.contentText}>
                  <FormattedMessage
                    id="aboutUs.vision.point2"
                    defaultMessage="Whether you're experimenting with a new look, avoiding outfit repeats, or dressing up for a special occasion, RET makes it easier than ever."
                  />
                </p>
              </div>
              <div className={styles.contentItem}>
                <div className={styles.contentBullet}></div>
                <p className={styles.contentText}>
                  <FormattedMessage
                    id="aboutUs.vision.point3"
                    defaultMessage="Fashion should be fun, flexible, and sustainable—and we're here to make that a reality."
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
